/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboDeclarationBadRequestResponse,
  BboDeclarationFailureResponseResponse,
  ForbiddenResponse,
  GetBpTpDetailsParams,
  GetBpTpResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get details by BPDeclarationID or TPDeclarationID
 */
export const getBpTpDetails = (
  declarationType: 'BP' | 'TP',
  params: GetBpTpDetailsParams,
  signal?: AbortSignal,
) => {
  return customInstance<GetBpTpResponseResponse>({
    url: `/bm-declaration-service/v1/${declarationType}`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetBpTpDetailsQueryKey = (
  declarationType: 'BP' | 'TP',
  params: GetBpTpDetailsParams,
) => {
  return [`/bm-declaration-service/v1/${declarationType}`, ...(params ? [params] : [])] as const;
};

export const getGetBpTpDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getBpTpDetails>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  declarationType: 'BP' | 'TP',
  params: GetBpTpDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBpTpDetails>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBpTpDetailsQueryKey(declarationType, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBpTpDetails>>> = ({ signal }) =>
    getBpTpDetails(declarationType, params, signal);

  return { queryKey, queryFn, enabled: !!declarationType, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBpTpDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBpTpDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getBpTpDetails>>>;
export type GetBpTpDetailsQueryError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary Get details by BPDeclarationID or TPDeclarationID
 */
export const useGetBpTpDetails = <
  TData = Awaited<ReturnType<typeof getBpTpDetails>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  declarationType: 'BP' | 'TP',
  params: GetBpTpDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBpTpDetails>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBpTpDetailsQueryOptions(declarationType, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
